import { applyWindow } from './applyWindow';
import { compose } from './compose';
export function apodization(data, options = {}) {
    const { compose: composeOptions, pointsToShift, apply = true } = options;
    if (!composeOptions) {
        return { ...data, windowData: new Float64Array(data.re.length).fill(1) };
    }
    const windowData = compose(composeOptions);
    const applyWindowOptions = {
        windowData,
        pointsToShift,
    };
    const re = apply ? applyWindow(data.re, applyWindowOptions) : data.re;
    const im = apply ? applyWindow(data.im, applyWindowOptions) : data.im;
    return { re, im, windowData };
}
//# sourceMappingURL=apodization.js.map